import { Navigate, Outlet, RouteObject } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import RootPage from "../pages/RootPage";
import WelcomePage from "../pages/WelcomePage";
import ErrorElement from "../pages/ErrorElement";
import { ControlAccess } from "../components/ControlAccess/ControlAccess";
import { tokenService } from "../services/token.service";
import { getEstablishmentCode } from "../services/establishment.service";
import NoAccessPage from "../pages/NoAccessPage";
import ForgetPasswordPage from "../pages/ForgetPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import AccessRoutes from "./access";
import AdminRoutes from "./admin";
import ChangePasswordPage from "../pages/ChangePassword/ChangePasswordPage";
import DevelopmentPage from "pages/Development";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={`/e/${getEstablishmentCode()}`} />,
    errorElement: <ErrorElement />,
  },
  {
    path: "/e/:eI",
    element: (
      <ControlAccess
        canAccess={() => tokenService.hasAccessTokens()}
        redirectUrl="/login"
      >
        <RootPage />
      </ControlAccess>
    ),
    errorElement: <ErrorElement />,
    children: [
      {
        index: true,
        element: <WelcomePage />,
      },
      {
        path: "acessos",
        element: <Outlet />,
        children: AccessRoutes,
      },
      {
        path: "administrativo",
        element: <Outlet />,
        children: AdminRoutes,
      },
      {
        path: "no-access",
        element: <NoAccessPage />,
      },
      {
        path: "alterar-senha",
        element: (
          <ControlAccess
            canAccess={() => tokenService.hasAccessTokens()}
            redirectUrl="/"
          >
            <ChangePasswordPage />
          </ControlAccess>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: (
      <ControlAccess
        canAccess={() => !tokenService.hasAccessTokens()}
        redirectUrl="/"
      >
        <LoginPage />
      </ControlAccess>
    ),
  },
  {
    path: "/esqueci-senha",
    element: <ForgetPasswordPage />,
  },
  {
    path: "/resetPassword/:token",
    element: <ResetPasswordPage />,
  },
  {
    path: "/development",
    element: (
      <DevelopmentPage />
    ),
  },
];

export default routes;
